import api from "@/api/api";

export const checkPdfExportStatus = (jobId) => {
  return api.get(`essays/export/pdf-async/${jobId}`);
};

export const startPdfExport = (props) => {
  return api.put("essays/export/pdf-async", props);
};
